var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbbNodataInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f36831;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "abb_information-circle-1_24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Final_icons_-_Common",
    "data-name": "Final icons - Common"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm1,11v6H11V12H10V10h2a1,1,0,0,1,1,1ZM11.5,8A1.5,1.5,0,1,1,13,6.5,1.5,1.5,0,0,1,11.5,8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbbNodataInformation);
export default __webpack_public_path__ + "static/media/abb_nodata_information.f1c900913934663566d72b690a402d6d.svg";
export { ForwardRef as ReactComponent };